// This file is auto-generated by the FontAwesome scanner plugin
// Do not edit manually - it will be overwritten on build

import { library } from '@fortawesome/fontawesome-svg-core';

import {
    faArrowDown as fasArrowDown,
    faArrowLeft as fasArrowLeft,
    faArrowRight as fasArrowRight,
    faArrowsAlt as fasArrowsAlt,
    faArrowsRotate as fasArrowsRotate,
    faArrowUp as fasArrowUp,
    faArrowUpRightFromSquare as fasArrowUpRightFromSquare,
    faBan as fasBan,
    faBars as fasBars,
    faBell as fasBell,
    faBook as fasBook,
    faBookOpen as fasBookOpen,
    faBoxArchive as fasBoxArchive,
    faBoxes as fasBoxes,
    faBoxOpen as fasBoxOpen,
    faBroom as fasBroom,
    faBug as fasBug,
    faBullhorn as fasBullhorn,
    faCalendarAlt as fasCalendarAlt,
    faCalendarCheck as fasCalendarCheck,
    faCaretDown as fasCaretDown,
    faCartShopping as fasCartShopping,
    faChartArea as fasChartArea,
    faChartLine as fasChartLine,
    faChartPie as fasChartPie,
    faCheck as fasCheck,
    faCheckCircle as fasCheckCircle,
    faChevronDown as fasChevronDown,
    faChevronLeft as fasChevronLeft,
    faChevronRight as fasChevronRight,
    faChevronUp as fasChevronUp,
    faCircleCheck as fasCircleCheck,
    faCircleExclamation as fasCircleExclamation,
    faCircleInfo as fasCircleInfo,
    faCircleNotch as fasCircleNotch,
    faCirclePlay as fasCirclePlay,
    faCircleQuestion as fasCircleQuestion,
    faCircleXmark as fasCircleXmark,
    faClock as fasClock,
    faClockRotateLeft as fasClockRotateLeft,
    faClone as fasClone,
    faCloud as fasCloud,
    faCloudArrowDown as fasCloudArrowDown,
    faCloudArrowUp as fasCloudArrowUp,
    faCloudUploadAlt as fasCloudUploadAlt,
    faCode as fasCode,
    faCodeBranch as fasCodeBranch,
    faCodeCompare as fasCodeCompare,
    faCog as fasCog,
    faCogs as fasCogs,
    faComputer as fasComputer,
    faCopy as fasCopy,
    faCube as fasCube,
    faCubes as fasCubes,
    faDatabase as fasDatabase,
    faDoorOpen as fasDoorOpen,
    faDownload as fasDownload,
    faEdit as fasEdit,
    faEgg as fasEgg,
    faEllipsisH as fasEllipsisH,
    faEnvelope as fasEnvelope,
    faExclamationTriangle as fasExclamationTriangle,
    faExpand as fasExpand,
    faExternalLinkAlt as fasExternalLinkAlt,
    faExternalLinkSquareAlt as fasExternalLinkSquareAlt,
    faEye as fasEye,
    faFile as fasFile,
    faFileAlt as fasFileAlt,
    faFileArchive as fasFileArchive,
    faFileImport as fasFileImport,
    faFileInvoice as fasFileInvoice,
    faFileLines as fasFileLines,
    faFileUpload as fasFileUpload,
    faFilter as fasFilter,
    faFingerprint as fasFingerprint,
    faFloppyDisk as fasFloppyDisk,
    faFolder as fasFolder,
    faFolderOpen as fasFolderOpen,
    faFolderPlus as fasFolderPlus,
    faFolderTree as fasFolderTree,
    faFont as fasFont,
    faGamepad as fasGamepad,
    faGear as fasGear,
    faGlobe as fasGlobe,
    faGripVertical as fasGripVertical,
    faHandshake as fasHandshake,
    faHardDrive as fasHardDrive,
    faHdd as fasHdd,
    faHeartbeat as fasHeartbeat,
    faHome as fasHome,
    faHouse as fasHouse,
    faIdBadge as fasIdBadge,
    faImage as fasImage,
    faInfoCircle as fasInfoCircle,
    faKey as fasKey,
    faLayerGroup as fasLayerGroup,
    faLevelUpAlt as fasLevelUpAlt,
    faLifeRing as fasLifeRing,
    faLink as fasLink,
    faLinkSlash as fasLinkSlash,
    faList as fasList,
    faLocationDot as fasLocationDot,
    faLock as fasLock,
    faLockOpen as fasLockOpen,
    faMagnifyingGlass as fasMagnifyingGlass,
    faMap as fasMap,
    faMapMarkedAlt as fasMapMarkedAlt,
    faMemory as fasMemory,
    faNetworkWired as fasNetworkWired,
    faPaintbrush as fasPaintbrush,
    faPalette as fasPalette,
    faPen as fasPen,
    faPencil as fasPencil,
    faPenToSquare as fasPenToSquare,
    faPeopleRoof as fasPeopleRoof,
    faPlay as fasPlay,
    faPlayCircle as fasPlayCircle,
    faPlug as fasPlug,
    faPlus as fasPlus,
    faPowerOff as fasPowerOff,
    faPuzzlePiece as fasPuzzlePiece,
    faQuestion as fasQuestion,
    faRandom as fasRandom,
    faRectangleXmark as fasRectangleXmark,
    faRotate as fasRotate,
    faRotateLeft as fasRotateLeft,
    faRotateRight as fasRotateRight,
    faSave as fasSave,
    faSearch as fasSearch,
    faServer as fasServer,
    faShield as fasShield,
    faShieldAlt as fasShieldAlt,
    faShieldHalved as fasShieldHalved,
    faSignature as fasSignature,
    faSignOutAlt as fasSignOutAlt,
    faSkull as fasSkull,
    faSlidersH as fasSlidersH,
    faSpinner as fasSpinner,
    faStar as fasStar,
    faStop as fasStop,
    faStopwatch as fasStopwatch,
    faSync as fasSync,
    faTachometerAlt as fasTachometerAlt,
    faTerminal as fasTerminal,
    faTextWidth as fasTextWidth,
    faTicket as fasTicket,
    faTimes as fasTimes,
    faTrash as fasTrash,
    faTrashAlt as fasTrashAlt,
    faTriangleExclamation as fasTriangleExclamation,
    faTruckFast as fasTruckFast,
    faUpload as fasUpload,
    faUser as fasUser,
    faUsers as fasUsers,
    faWandMagicSparkles as fasWandMagicSparkles,
    faWarning as fasWarning,
    faWifi as fasWifi,
    faWrench as fasWrench,
    faX as fasX,
    faXmark as fasXmark
} from '@fortawesome/free-solid-svg-icons';

import {
    faClock as farClock,
    faHeart as farHeart,
    faPaste as farPaste,
    faStar as farStar
} from '@fortawesome/free-regular-svg-icons';

import {
    faBitbucket as fabBitbucket,
    faDiscord as fabDiscord,
    faGit as fabGit,
    faGithub as fabGithub,
    faGitlab as fabGitlab,
    faSteam as fabSteam,
    faYoutube as fabYoutube
} from '@fortawesome/free-brands-svg-icons';

library.add(
    /* SOLID */
    fasArrowDown, fasArrowLeft, fasArrowRight, fasArrowsAlt, fasArrowsRotate, fasArrowUp, fasArrowUpRightFromSquare, fasBan, fasBars, fasBell, fasBook, fasBookOpen, fasBoxArchive, fasBoxes, fasBoxOpen, fasBroom, fasBug, fasBullhorn, fasCalendarAlt, fasCalendarCheck, fasCaretDown, fasCartShopping, fasChartArea, fasChartLine, fasChartPie, fasCheck, fasCheckCircle, fasChevronDown, fasChevronLeft, fasChevronRight, fasChevronUp, fasCircleCheck, fasCircleExclamation, fasCircleInfo, fasCircleNotch, fasCirclePlay, fasCircleQuestion, fasCircleXmark, fasClock, fasClockRotateLeft, fasClone, fasCloud, fasCloudArrowDown, fasCloudArrowUp, fasCloudUploadAlt, fasCode, fasCodeBranch, fasCodeCompare, fasCog, fasCogs, fasComputer, fasCopy, fasCube, fasCubes, fasDatabase, fasDoorOpen, fasDownload, fasEdit, fasEgg, fasEllipsisH, fasEnvelope, fasExclamationTriangle, fasExpand, fasExternalLinkAlt, fasExternalLinkSquareAlt, fasEye, fasFile, fasFileAlt, fasFileArchive, fasFileImport, fasFileInvoice, fasFileLines, fasFileUpload, fasFilter, fasFingerprint, fasFloppyDisk, fasFolder, fasFolderOpen, fasFolderPlus, fasFolderTree, fasFont, fasGamepad, fasGear, fasGlobe, fasGripVertical, fasHandshake, fasHardDrive, fasHdd, fasHeartbeat, fasHome, fasHouse, fasIdBadge, fasImage, fasInfoCircle, fasKey, fasLayerGroup, fasLevelUpAlt, fasLifeRing, fasLink, fasLinkSlash, fasList, fasLocationDot, fasLock, fasLockOpen, fasMagnifyingGlass, fasMap, fasMapMarkedAlt, fasMemory, fasNetworkWired, fasPaintbrush, fasPalette, fasPen, fasPencil, fasPenToSquare, fasPeopleRoof, fasPlay, fasPlayCircle, fasPlug, fasPlus, fasPowerOff, fasPuzzlePiece, fasQuestion, fasRandom, fasRectangleXmark, fasRotate, fasRotateLeft, fasRotateRight, fasSave, fasSearch, fasServer, fasShield, fasShieldAlt, fasShieldHalved, fasSignature, fasSignOutAlt, fasSkull, fasSlidersH, fasSpinner, fasStar, fasStop, fasStopwatch, fasSync, fasTachometerAlt, fasTerminal, fasTextWidth, fasTicket, fasTimes, fasTrash, fasTrashAlt, fasTriangleExclamation, fasTruckFast, fasUpload, fasUser, fasUsers, fasWandMagicSparkles, fasWarning, fasWifi, fasWrench, fasX, fasXmark,

    /* REGULAR */
    farClock, farHeart, farPaste, farStar,

    /* BRANDS */
    fabBitbucket, fabDiscord, fabGit, fabGithub, fabGitlab, fabSteam, fabYoutube,
);
